module.exports = __webpack_public_path__ + "img/icn-close.f1d13897.svg";